﻿'use strict';

angular.module('ntmApp').factory('ForecastSummary', ['ForecastService', 'Constants', 'Comparers', function (ForecastService, Constants, Comparers) {

    function ForecastSummary(forecastContext) {

        var self = this;
        var context = forecastContext;

        self.periodSummaryProperties = [
            { name: 'forecastDescription', label: 'Forecast' },
            { name: 'totalActivityHours', label: 'Total Activity Hours' },
            { name: 'dayCount', label: 'Day Range' },
            { name: 'totalCapacityHours', label: 'Total Capacity Hours' },
            { name: 'unAassignedActivityHours', label: 'Un-assigned Activity Hours' },
            { name: 'staffUnderAllocated', label: 'Staff Under-allocated' },
            { name: 'staffOverAllocated', label: 'Staff Over-allocated' }
        ];

        self.dailyBreakdownSummaryProperties = [
            { name: 'title', label: 'Statistic' },
            { name: 'activityMin', label: 'Total Activity Min' },
            { name: 'staffCapacityMin', label: 'Total Staff Capacity' },
            { name: 'unAssignedActivityMin', label: 'Un-assigned Activity Min' },
            { name: 'overAllocatedStaffCount', label: 'Over-allocated Staff Count' },
            { name: 'underAllocatedStaffCount', label: 'Under-allocated Staff Count' }
        ];


        self.load = function (header, weeks) {


            var request = context.prepareDataForRequest();

            request.forecastView = header.forecastOptionsSummary.forecastView;
            request.forecastScope = header.selectedForecastScope.id.trim();
            request.dateFrom = moment(header.dateFrom);
            request.dateTo = moment(header.dateTo);

            self.isLoading = true;
            ForecastService.GetForecastSummaryMenu(request).then(function (result) {

                var mode = request.forecastMode;
                var scenarioName = request.scenarioName;

                if (result.success) {

                    if (result.data.forecastPeriods) {
                        self.forecastPeriodSummary = result.data.forecastPeriods.sortBy(Comparers.ScenarioComparer, 'forecastDescription');

                        if (mode === Constants.ForecastMode.CurrentForecast) {
                            selectViewedForecastPeriodSummary(self.forecastPeriodSummary.firstOrDefault(function (record) {
                                return 'Current Forecast'.toUpperCase() === record.forecastDescription.toUpperCase();
                            }));
                        } else {
                            selectViewedForecastPeriodSummary(self.forecastPeriodSummary.firstOrDefault(function (record) {
                                return scenarioName.toUpperCase() === record.forecastDescription.toUpperCase();
                            }));
                        }
                    }

                    self.dailyBreakdownSummaryRecords = getDailyBreakDownSummaryWeeks(result.data.dailyBreakdownSummaryDays, weeks);
                }

            }).finally(function () {
                self.isLoading = false;
            });
        };

        function getDailyBreakDownSummaryWeeks(dailyBreakdownSummaryDays, weeks) {

            var result = [];

            weeks.forEach(function (week) {

                var weekTotal = {
                    title: 'Week {0}'.format(week.week),
                    isWeekTotal: true
                };

                var daysOfWeek = dailyBreakdownSummaryDays.filter(function (day) {

                    var dayDate = moment(day.date);
                    var weekStartDate = moment(moment(week.startDate).format('DD/MM/YYYY'), 'DD/MM/YYYY');
                    var weekEndtDate = moment(moment(week.endDate).format('DD/MM/YYYY'), 'DD/MM/YYYY');

                    return (dayDate.isSame(weekStartDate) || dayDate.isAfter(weekStartDate)) &&
                           (dayDate.isSame(weekEndtDate) || dayDate.isBefore(weekEndtDate));

                }).sort(function (day1, day2) {
                    return moment(day1.date).diff(moment(day2.date));
                });

                if (daysOfWeek.length > 0) {
                    weekTotal.activityMin = daysOfWeek.sumOf('activityMin');
                    weekTotal.overAllocatedStaffCount = daysOfWeek.sumOf('overAllocatedStaffCount');
                    weekTotal.staffCapacityMin = daysOfWeek.sumOf('staffCapacityMin');
                    weekTotal.unAssignedActivityMin = daysOfWeek.sumOf('unAssignedActivityMin');
                    weekTotal.underAllocatedStaffCount = daysOfWeek.sumOf('underAllocatedStaffCount');

                    result.push(weekTotal);
                    daysOfWeek.forEach(function (dayOfWeek) {
                        result.push(dayOfWeek);
                    });
                }
            });

            return result;

        }

        function selectViewedForecastPeriodSummary(record) {
			if(record) {
				self.forecastPeriodSummary.forEach(function (periodSummaryRecord) {
					periodSummaryRecord.isSelected = false;
				});

				record.isSelected = true;
			}
        }

        self.dailyBreakdownSummaryGridTitle = function () {

            if (self.forecastPeriodSummary) {
                var selectedPeriodSummary = self.forecastPeriodSummary.firstOrDefault(function (record) {
                    return record.isSelected;
                });

                return selectedPeriodSummary ? 'Daily Breakdown Summary for {0}'.format(selectedPeriodSummary.forecastDescription) :
                                               '';
            }

            return '';
        };
    }

    return (ForecastSummary);
}]);